import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class CentroService {
  documentos: any
  id: any
  centros: any = []
  constructor() { }

  getAllCentros() {
    return gql`
      query getAllCentros {
        centros(sort: "createdAt:DESC") {
          id
          nombre
          nima
          fechaAlta
          createdAt
          estado
          contratista {
            nombreComercial
          }
          clientes {
            nombreComercial
          }
          contacto {
            mail
          }
          direccion {
            tipoVia
            nombre
          }
          gestors{
            id
            estado
          }
          transportistas{
            id
            estado
          }
          documentos{
            estado 
            tipo
          }
        }
      }
    `;
  }

  getAllCentrosGreen() {
    return gql`
      query getAllCentros {
        centros(
          where: {
            estado: "verde"
          }) {
          id
          nombre
          nima
          fechaAlta
          createdAt
          estado
          contratista {
            nombreComercial
          }
          clientes {
            nombreComercial
          }
          contacto {
            mail
          }
          direccion {
            tipoVia
            nombre
          }
          gestors{
            id
            estado
          }
          transportistas{
            id
            estado
          }
          documentos{
            estado 
            tipo
          }
        }
      }
    `;
  }

  getAllCentrosYellow() {
    return gql`
      query getAllCentros {
        centros(
          where: {
            estado: "amarillo"
          }) {
          id
          nombre
          nima
          fechaAlta
          createdAt
          estado
          contratista {
            nombreComercial
          }
          clientes {
            nombreComercial
          }
          contacto {
            mail
          }
          direccion {
            tipoVia
            nombre
          }
          gestors{
            id
            estado
          }
          transportistas{
            id
            estado
          }
          documentos{
            estado 
            tipo
          }
        }
      }
    `;
  }

  getAllCentrosRed() {
    return gql`
      query getAllCentros {
        centros(
          where: {
            estado: "rojo"
          }) {
          id
          nombre
          nima
          fechaAlta
          createdAt
          estado
          contratista {
            nombreComercial
          }
          clientes {
            nombreComercial
          }
          contacto {
            mail
          }
          direccion {
            tipoVia
            nombre
          }
          gestors{
            id
            estado
          }
          transportistas{
            id
            estado
          }
          documentos{
            estado 
            tipo
          }
        }
      }
    `;
  }


  getAllCentrosDoughnout() {
    return gql`
    query getAllCentros {
      centros(sort: "createdAt:DESC") {
        id
        estado
        gestors {
          id
          estado
          documentos {
            estado
            tipo
          }
        }
        transportistas {
          id
          estado
          documentos {
            estado
            tipo	
          }
        }
        documentos {
          estado
          tipo
        }
      }
    }
    `;
  }

  getCentrosByGestor() {
    return gql`
      query getCentrosByGestor ($id: ID!) {
        gestor(id: $id) {
          centros {
            id
            nombre
            nima
            createdAt
            contratista {
              id
              nombreComercial
            }
            clientes {
              id
              nombreComercial
            }
            direccion{
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
            }
            contactoResponsable {
              nombre
           }
          }
        }
      }
    `;
  }

  getCentrosByTransportista() {
    return gql`
      query getCentrosByTransportista ($id: ID!) {
        transportista(id: $id) {
          centros {
            id
            nombre
            nima
            createdAt
            contratista {
              nombreComercial
              id
            }
            clientes {
              id
              nombreComercial
            }
            direccion{
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
            }
            contactoResponsable {
              nombre
           }
          }
        }
      }
    `;
  }

  getCentrosByInstalacion() {
    return gql`
      query getCentrosByInstalacion ($id: ID!) {
        instalacion(id: $id) {
          centro {
            id
            nombre
            nima
            createdAt
            contratista {
              nombreComercial
              id
            }
            clientes{
             nombreComercial
            }
            direccion{
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
            }
            contactoResponsable {
              nombre
           }
          }
        }
      }
    `;
  }



  addCentro() {
    return gql`
      mutation createCentro($input: createCentroInput!) {
      createCentro(input: $input) {
        centro {
          id
        }
      }
    }
    `;
  }

  updateCentro() {
    return gql`
      mutation updateCentro($input: updateCentroInput!) {
        updateCentro(input: $input) {
          centro {
            id
            
          }
        }
      }
    `;
  }

  deleteCentro() {
    return gql`
      mutation deleteCentro($input: deleteCentroInput!) {
        deleteCentro(input: $input) {
          centro {
            id
          }
        }
      }
    `;
  }

  getCentrosByContratista() {
    return gql`
      query getCentrosByContratista($id: ID!){
        contratista(id: $id){
          centros {
          id
          nombre
          nima 
          createdAt
          contratista {
            nombreComercial
          }
          clientes {
            nombreComercial
          }
        }
        }
      }
    `;
  }

  getCentrosByContratistaCliente() {
    return gql`
      query getCentrosByContratistaCliente($id: ID!){
        contratista(id: $id){
          centros {
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            clientes {
              id
            }
            contactoResponsable {
              nombre
              mail
            }
            contratista {
              nombreComercial
            }
          }
        }
      }
    `;
  }

  getCentrosByInstalacionCliente() {
    return gql`
      query getCentrosByInstalacionCliente($id: ID!){
        instalacion(id: $id){
          centro {
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            clientes {
              id
            }
            contactoResponsable {
              nombre
              mail
            }
            contratista {
              nombreComercial
            }
          }
        }
      }
    `;
  }


  getCentroById() {
    return gql`
    query getCentroById ($id: ID!) {
      centro(id: $id) {
        id
        nombre
        nima
        resPeligrosos
        GPResPeligrosos
        IdCentro
        documentos_adicionals{
          id
          nombreArchivo
        }
        licencias{
          IDLicencia
        }
        contratista {
          nombreComercial
        }
        direccion{
          tipoVia
          nombre
          provincia
          ccaa
          numero
          codigoPostal
        }
        contactoResponsable {
          nombre
          mail
        }
        contacto{
          nombre
          mail
          cargo
        }
        gestors {
          nombre
          id
          estado
        }
        transportistas {
          nombre
          id
          estado
        }
        instalaciones{
          nombre
          id
        }
        clientes{
          id
        }
        comentariosAdic1 {
          comentario
        }
        comentariosAdic2 {
          comentario
        }
        comentariosAdic3 {
          comentario
        }
      }
    }
  `;
  }

  getCentroByIdTablas() {
    return gql`
    query getCentroById ($id: ID!) {
      centro(id: $id) {
        id
        nombre
        nima
        resPeligrosos
        GPResPeligrosos
        contratista {
          nombreComercial
        }
        direccion{
          tipoVia
          nombre
          provincia
          ccaa
          codigoPostal
        }
        contactoResponsable {
          nombre
        
        }
        
      }
    }
  `;
  }

  setIdCentro(id: any) {
    this.id = id;
  }

  getIdCentro() {
    let temp = this.id;
    this.clearIdCentro();
    return temp;
  }

  clearIdCentro() {
    this.id = undefined;
  }

  setCentros(centro: any) {
    this.centros = centro;
  }

  getCentros() {
    let temp = this.centros;
    this.clearCentros();
    return temp;
  }

  clearCentros() {
    this.centros = undefined;
  }

}
